import { render, staticRenderFns } from "./exportEx.vue?vue&type=template&id=2d7ba7aa"
import script from "./exportEx.vue?vue&type=script&lang=js"
export * from "./exportEx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports